import PaymentDetailsCard from './PaymentDetailsCard'
export default PaymentDetailsCard
